import { render, staticRenderFns } from "./Pages.vue?vue&type=template&id=067ff0dd"
import script from "./Pages.vue?vue&type=script&lang=js"
export * from "./Pages.vue?vue&type=script&lang=js"
import style0 from "./Pages.vue?vue&type=style&index=0&id=067ff0dd&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports